"use client";

import { c as _c } from "react/compiler-runtime";
import { PostHogProvider } from "@/providers/PostHogProvider";
import { SessionProvider } from "next-auth/react";
import { ThemeProvider } from "next-themes";
export function Providers(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <SessionProvider><PostHogProvider><ThemeProvider attribute="class" defaultTheme="system" enableSystem={true} disableTransitionOnChange={true}>{children}</ThemeProvider></PostHogProvider></SessionProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}